import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import serverVars from 'server-vars';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { SharedRecentlyViewedItemsCarousel } from './SharedRecentlyViewedItemsCarousel';
import { SharedRecentlyViewedItemsSwiper } from '../SharedRecentlyViewedItemsSwiper/SharedRecentlyViewedItemsSwiper';
import { hasRecentlyViewedItems, getRecentlyViewedItems } from '../../utils/recentHistory';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './SharedRecentlyViewedItems.scss';
import {
    VERTICAL_OFFSET_RESP_IMG,
    HORIZONTAL_OFFSET_RESP_IMG,
} from '../../constants/imageConstants';

const recentlyViewed = (
    <FormattedMessage id="shared.recentlyViewed" defaultMessage="Recently Viewed" />
);

const SharedRecentlyViewedItems = ({
    itemId,
    isClient,
    wrapperClassName,
    arrowClassName,
    placeholderClassName,
    itemImageClassName,
    showBarHeader,
    itemsPerPage,
}) => {
    if (!isClient || !hasRecentlyViewedItems({ itemId })) {
        return null;
    }
    const items = getRecentlyViewedItems({ itemId });
    const itemClasses = classnames(styles.item, { [styles.center]: items && items.length < 3 });
    const header = showBarHeader ? (
        <BarHeader title={recentlyViewed} />
    ) : (
        <p className={styles.header}>{recentlyViewed}</p>
    );
    return (
        <Fragment>
            {header}
            {serverVars.get('settings.isTablet') ? (
                <SharedRecentlyViewedItemsSwiper
                    items={items}
                    itemsPerPage={4.5}
                    offsetVertical={VERTICAL_OFFSET_RESP_IMG}
                    offsetHorizontal={HORIZONTAL_OFFSET_RESP_IMG}
                    classNames={{
                        wrapper: wrapperClassName || styles.wrapper,
                        item: itemClasses,
                        list: items && items.length > 5 ? '' : styles.list,
                        placeholder: placeholderClassName || styles.placeholder,
                        itemImage: itemImageClassName || styles.itemImage,
                    }}
                />
            ) : (
                <SharedRecentlyViewedItemsCarousel
                    items={items}
                    itemsPerPage={itemsPerPage}
                    classNames={{
                        list: items && items.length > itemsPerPage ? '' : styles.list,
                        placeholder: styles.placeholder,
                        itemLink: styles.itemLink,
                        itemImage: styles.itemImage,
                        arrow: arrowClassName,
                    }}
                />
            )}
        </Fragment>
    );
};

SharedRecentlyViewedItems.defaultProps = {
    showBarHeader: true,
    itemsPerPage: 6,
};

SharedRecentlyViewedItems.propTypes = {
    arrowClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
    placeholderClassName: PropTypes.string,
    itemImageClassName: PropTypes.string,
    itemId: PropTypes.string,
    isClient: PropTypes.bool.isRequired,
    showBarHeader: PropTypes.bool.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
};

export { SharedRecentlyViewedItems };
